/**
 * Artemis Application Server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * API Version: 10.6
 * Contact: krusche@tum.de
 *
 * NOTE: This file is auto-generated. Do not edit manually.
 */

/**
 * HyperionExerciseGenerationApi - API service
 * @generated from OpenAPI specification
 */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExerciseGenerationRequest } from '../model/exercise-generation-request';
import { ExerciseGenerationJobStart } from '../model/exercise-generation-job-start';
import { ExerciseGenerationStatus } from '../model/exercise-generation-status';
import { ExerciseGenerationCapabilities } from '../model/exercise-generation-capabilities';
import { ExerciseGenerationEffortProfile } from '../model/exercise-generation-effort-profile';
import { ExerciseGenerationRetainedArtifacts } from '../model/exercise-generation-retained-artifacts';
import { ExerciseGenerationRevertResult } from '../model/exercise-generation-revert-result';
import { ExerciseGenerationMetadataSuggestionRequest } from '../model/exercise-generation-metadata-suggestion-request';
import { ExerciseGenerationMetadataSuggestionResponse } from '../model/exercise-generation-metadata-suggestion-response';

@Injectable({ providedIn: 'root' })
export class HyperionExerciseGenerationApi {
    private readonly http = inject(HttpClient);
    private readonly basePath = '';

    /**
     *
     *
     * @param exerciseId
     * @param jobId
     */
    cancelExerciseGeneration(exerciseId: number, jobId: string): Observable<void> {
        const jobIdPath = encodeURIComponent(String(jobId));
        const url = `${this.basePath}/api/hyperion/programming-exercises/${exerciseId}/generate-exercise/jobs/${jobIdPath}`;
        return this.http.delete<void>(url);
    }

    /**
     *
     *
     * @param exerciseId
     * @param exerciseGenerationRequest
     */
    generateExercise(exerciseId: number, exerciseGenerationRequest: ExerciseGenerationRequest): Observable<ExerciseGenerationJobStart> {
        const url = `${this.basePath}/api/hyperion/programming-exercises/${exerciseId}/generate-exercise`;
        return this.http.post<ExerciseGenerationJobStart>(url, exerciseGenerationRequest);
    }

    /**
     *
     *
     * @param exerciseId
     */
    getExerciseGenerationStatus(exerciseId: number): Observable<ExerciseGenerationStatus> {
        const url = `${this.basePath}/api/hyperion/programming-exercises/${exerciseId}/generate-exercise/status`;
        return this.http.get<ExerciseGenerationStatus>(url);
    }

    /**
     *
     *
     * @param exerciseId
     */
    getGenerationCapabilities(exerciseId: number): Observable<ExerciseGenerationCapabilities> {
        const url = `${this.basePath}/api/hyperion/programming-exercises/${exerciseId}/generation/capabilities`;
        return this.http.get<ExerciseGenerationCapabilities>(url);
    }

    /**
     *
     *
     */
    getGenerationEffortProfiles(): Observable<Array<ExerciseGenerationEffortProfile>> {
        const url = `${this.basePath}/api/hyperion/programming-exercises/generation/effort-profiles`;
        return this.http.get<Array<ExerciseGenerationEffortProfile>>(url);
    }

    /**
     *
     *
     * @param exerciseId
     */
    getRetainedGenerationArtifacts(exerciseId: number): Observable<ExerciseGenerationRetainedArtifacts> {
        const url = `${this.basePath}/api/hyperion/programming-exercises/${exerciseId}/generate-exercise/artifacts`;
        return this.http.get<ExerciseGenerationRetainedArtifacts>(url);
    }

    /**
     *
     *
     */
    getSupportedGenerationLanguages(): Observable<Array<string>> {
        const url = `${this.basePath}/api/hyperion/programming-exercises/generation/supported-languages`;
        return this.http.get<Array<string>>(url);
    }

    /**
     *
     *
     * @param exerciseId
     * @param runId
     */
    revertExerciseGeneration(exerciseId: number, runId: string): Observable<ExerciseGenerationRevertResult> {
        const runIdPath = encodeURIComponent(String(runId));
        const url = `${this.basePath}/api/hyperion/programming-exercises/${exerciseId}/generation/runs/${runIdPath}/revert`;
        return this.http.post<ExerciseGenerationRevertResult>(url, null);
    }

    /**
     *
     *
     * @param courseId
     * @param exerciseGenerationMetadataSuggestionRequest
     */
    suggestGenerationMetadata(courseId: number, exerciseGenerationMetadataSuggestionRequest: ExerciseGenerationMetadataSuggestionRequest): Observable<ExerciseGenerationMetadataSuggestionResponse> {
        const url = `${this.basePath}/api/hyperion/courses/${courseId}/programming-exercises/generation/metadata-suggestion`;
        return this.http.post<ExerciseGenerationMetadataSuggestionResponse>(url, exerciseGenerationMetadataSuggestionRequest);
    }

}
